








































import HitRate from "@/components/HitRate.vue";
import { getValuesIdxByMetric, getMetricLabel } from "@/utils/chart";
import { PREVIEW_PREFIXES_STATS } from "@/config/preview";
import { Prefix, PrefixStats } from "@/types/debug-mode";
import { SeriesPoint } from "@/types/common";
import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({ components: { HitRate } })
export default class PrefixesOverallStats extends Vue {
  @State(state => state.debugMode.prefixStats)
  prefixStats!: PrefixStats;
  @State(state => state.debugMode.prefixes) prefixes!: Prefix[] | null;

  @Getter("debugMode/prefixLastStats") lastStats!: (prefixID: number) => SeriesPoint | null | false;

  @Getter("debugMode/prefixStatsSeriesColumns") columns!: (prefixID: number) => false | string[];

  @Getter("debugMode/allPrefixLastStatsFetched")
  allPrefixLastStatsFetched!: boolean;

  // prefixes excluding sub prefixes
  // TODO essentially same logic as filterSubPrefixes() in PrefixesPopular
  get topLevelPrefixes() {
    if (!this.prefixes) {
      return [];
    }

    let previous: string;

    // Note: prefixes are sorted when fetched, they
    // must be sorted for filtering to work
    return this.prefixes.filter(prefix => {
      const current = prefix.name;

      // `previous` is initially undefined, only check for a sub prefix match
      // when `previous` has been set. In other words, always keep the first prefix
      if (previous) {
        // slice the first x chars of the current prefix name,
        // where x is the length of the previous prefix name
        const currentSlice = current.slice(0, previous.length);

        // if the current prefix name starts with the previous
        // prefix name, remove, and keep the same `previous` value
        if (currentSlice === previous) {
          return false;
        }
      }

      previous = current;
      return true;
    });
  }

  get lastPointsSummed(): SeriesPoint | false {
    if (!this.prefixes) return false; // loading
    if (!this.allPrefixLastStatsFetched) return false; // loading

    let sumPoint: SeriesPoint = [];

    // skip sub prefixes
    const topLevelPrefixIDs = this.topLevelPrefixes.map(prefix => prefix.id);

    for (const prefixID of topLevelPrefixIDs) {
      const lastPoint: SeriesPoint | null | false = this.lastStats(prefixID);

      if (!lastPoint) continue;

      if (sumPoint.length === 0) {
        // copy initial values, without reference
        sumPoint = [...lastPoint];
      } else {
        // start at 1 to skip time
        for (let i = 1; i < lastPoint.length; i++) {
          const nextVal = lastPoint[i];
          // Only sum numbers. Values could be null, and `null + null = 0`.
          if ((nextVal === 0 || nextVal) && typeof nextVal === "number") {
            sumPoint[i] += lastPoint[i];
          }
        }
      }
    }

    return sumPoint;
  }

  getPercentByMetric(metricID: string) {
    if (!this.prefixes) return false; // loading
    if (this.lastPointsSummed === false) return false; // loading

    // if disabled, show sample preview data
    if (this.prefixes && this.prefixes.length === 0) {
      return PREVIEW_PREFIXES_STATS[3][metricID];
    }

    const columns = this.columns(this.prefixes[0].id);
    if (!columns) return false; // loading...

    const i = getValuesIdxByMetric(columns, metricID);
    const val = this.lastPointsSummed[i];

    if ((val === 0 || val) && typeof val === "number") {
      return `${(val * 100).toFixed()}%`;
    }
    return val;
  }

  metricLabel(metricID: string): string {
    return getMetricLabel(metricID);
  }
}
